import api from './axios';

export const getDailyNotes = (params) => api.get('/daily-notes', { params });
export const createDailyNote = (data) => api.post('/daily-notes', data);
export const deleteDailyNote = (id) => api.delete(`/daily-notes/${id}`);
